webpackJsonp([50578359543744],{

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(98);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Create Load More Button'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll create the Load More button that we\'ll need for infinite scrolling.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'infinite-scrolling.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Button Behavior'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The first component we\'re going to create will be the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'LoadMoreButton'
	      ),
	      '. The user will click this button to load more tweets, and it will have three responsibilities:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Display the text "Load More" if there are more tweets to load'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Display a loading experience if more tweets are being fetched'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Disappear from view if there are no more tweets to fetch.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add NextPage to Collection Metadata'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s start by expanding the metadata for a collection to know whether there is a "next page" of data to load.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To do that, take a look at the API response for any endpoint that returns a collection:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        data: [\n          {...tweet...},\n          {...tweet...}\n        ],\n        meta: {\n          paginate: {\n            currentPage: 1,\n            nextPage: 2,\n            prevPage: null,\n            totalPages: 11,\n            totalCount: 51,\n            perPage: 5\n          }\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There\'s a field in ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'meta.paginate'
	      ),
	      ' called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'nextPage'
	      ),
	      ', and this field will either contain the number of the next page of data or be null if there are no more pages to display.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To use that field in our application, we need to add it to be ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'meta'
	      ),
	      ' property of collections. To do that, open ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/connections.js'
	      ),
	      ' and update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method for collections to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // config/connections.js\n      ...\n        parse: function(response) {\n          this.meta = {\n            totalCount: response.meta.paginate.totalCount,\n            perPage: response.meta.paginate.perPage,\n            nextPage: response.meta.paginate.nextPage\n          };\n          return response.data;\n        }\n      ...\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With that change, we\'ll now be able to discover if there\'s a next page of data by inspecting ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.meta.nextPage'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Create the Button'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next, create the button component by running the following command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      lore generate component LoadMoreButton\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then modify the file to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import PayloadStates from \'../constants/PayloadStates\';\n\n        export default createReactClass({\n          displayName: \'LoadMoreButton\',\n\n          propTypes: {\n            lastPage: PropTypes.object.isRequired,\n            onLoadMore: PropTypes.func.isRequired,\n            nextPageMetaField: PropTypes.string.isRequired\n          },\n\n          render() {\n            const {\n              lastPage,\n              onLoadMore,\n              nextPageMetaField\n            } = this.props;\n\n            if(lastPage.state === PayloadStates.FETCHING) {\n              return (\n                <div className="footer">\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            if (!lastPage.meta[nextPageMetaField]) {\n              return (\n                <div className="footer"/>\n              );\n            }\n\n            return (\n              <div className="footer">\n                <button className="btn btn-default btn-lg" onClick={onLoadMore}>\n                  Load More\n                </button>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import PayloadStates from \'../constants/PayloadStates\';\n\n        class LoadMoreButton extends React.Component {\n\n          render() {\n            const {\n              lastPage,\n              onLoadMore,\n              nextPageMetaField\n            } = this.props;\n\n            if(lastPage.state === PayloadStates.FETCHING) {\n              return (\n                <div className="footer">\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            if (!lastPage.meta[nextPageMetaField]) {\n              return (\n                <div className="footer"/>\n              );\n            }\n\n            return (\n              <div className="footer">\n                <button className="btn btn-default btn-lg" onClick={onLoadMore}>\n                  Load More\n                </button>\n              </div>\n            );\n          }\n        }\n\n        LoadMoreButton.propTypes = {\n          lastPage: PropTypes.object.isRequired,\n          onLoadMore: PropTypes.func.isRequired,\n          nextPageMetaField: PropTypes.string.isRequired\n        };\n\n        export default LoadMoreButton;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import PayloadStates from \'../constants/PayloadStates\';\n\n        class LoadMoreButton extends React.Component {\n\n          static propTypes = {\n            lastPage: PropTypes.object.isRequired,\n            onLoadMore: PropTypes.func.isRequired,\n            nextPageMetaField: PropTypes.string.isRequired\n          };\n\n          render() {\n            const {\n              lastPage,\n              onLoadMore,\n              nextPageMetaField\n            } = this.props;\n\n            if(lastPage.state === PayloadStates.FETCHING) {\n              return (\n                <div className="footer">\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            if (!lastPage.meta[nextPageMetaField]) {\n              return (\n                <div className="footer"/>\n              );\n            }\n\n            return (\n              <div className="footer">\n                <button className="btn btn-default btn-lg" onClick={onLoadMore}>\n                  Load More\n                </button>\n              </div>\n            );\n          }\n        }\n\n        export default LoadMoreButton;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this. Still exactly the same :)'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'config/connections.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import auth from \'../src/utils/auth\';\n\n      export default {\n\n        default: {\n\n          apiRoot: \'http://localhost:1337\',\n\n          headers: function() {\n            return {\n              Authorization: `Bearer ${auth.getToken()}`\n            };\n          },\n\n          collections: {\n            properties: {\n              parse: function(response) {\n                this.meta = {\n                  totalCount: response.meta.paginate.totalCount,\n                  perPage: response.meta.paginate.perPage,\n                  nextPage: response.meta.paginate.nextPage\n                };\n                return response.data;\n              }\n            }\n          }\n\n        }\n      };\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/LoadMoreButton.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import PayloadStates from \'../constants/PayloadStates\';\n\n        export default createReactClass({\n          displayName: \'LoadMoreButton\',\n\n          propTypes: {\n            lastPage: PropTypes.object.isRequired,\n            onLoadMore: PropTypes.func.isRequired,\n            nextPageMetaField: PropTypes.string.isRequired\n          },\n\n          render() {\n            const {\n              lastPage,\n              onLoadMore,\n              nextPageMetaField\n            } = this.props;\n\n            if(lastPage.state === PayloadStates.FETCHING) {\n              return (\n                <div className="footer">\n                  <div className="loader" />\n                </div>\n              );\n            }\n\n            if (!lastPage.meta[nextPageMetaField]) {\n              return (\n                <div className="footer" />\n              );\n            }\n\n            return (\n              <div className="footer">\n                <button className="btn btn-default btn-lg" onClick={onLoadMore}>\n                  Load More\n                </button>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import PayloadStates from \'../constants/PayloadStates\';\n\n        class LoadMoreButton extends React.Component {\n\n          render() {\n            const {\n              lastPage,\n              onLoadMore,\n              nextPageMetaField\n            } = this.props;\n\n            if(lastPage.state === PayloadStates.FETCHING) {\n              return (\n                <div className="footer">\n                  <div className="loader" />\n                </div>\n              );\n            }\n\n            if (!lastPage.meta[nextPageMetaField]) {\n              return (\n                <div className="footer" />\n              );\n            }\n\n            return (\n              <div className="footer">\n                <button className="btn btn-default btn-lg" onClick={onLoadMore}>\n                  Load More\n                </button>\n              </div>\n            );\n          }\n\n        }\n\n        LoadMoreButton.propTypes = {\n          lastPage: PropTypes.object.isRequired,\n          onLoadMore: PropTypes.func.isRequired,\n          nextPageMetaField: PropTypes.string.isRequired\n        };\n\n        export default LoadMoreButton;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import PayloadStates from \'../constants/PayloadStates\';\n\n        class LoadMoreButton extends React.Component {\n\n          static propTypes = {\n            lastPage: PropTypes.object.isRequired,\n            onLoadMore: PropTypes.func.isRequired,\n            nextPageMetaField: PropTypes.string.isRequired\n          };\n\n          render() {\n            const {\n              lastPage,\n              onLoadMore,\n              nextPageMetaField\n            } = this.props;\n\n            if(lastPage.state === PayloadStates.FETCHING) {\n              return (\n                <div className="footer">\n                  <div className="loader" />\n                </div>\n              );\n            }\n\n            if (!lastPage.meta[nextPageMetaField]) {\n              return (\n                <div className="footer" />\n              );\n            }\n\n            return (\n              <div className="footer">\n                <button className="btn btn-default btn-lg" onClick={onLoadMore}>\n                  Load More\n                </button>\n              </div>\n            );\n          }\n        }\n\n        export default LoadMoreButton;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'ll ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'create the second component we\'ll need for Infinite Scrolling'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-infinite-scrolling-step-1-js-cc6257b879f896ed2a87.js